var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
import './index.css';
import OpenAI from "openai";
import { getClientSideEnvVar } from "./envUtils";
// Export both tools
export { default as AITextInlineTool } from './inline';
var AITextTool = /** @class */ (function () {
    function AITextTool(_a) {
        var data = _a.data, config = _a.config, api = _a.api, readOnly = _a.readOnly, block = _a.block;
        // CSS classes for styling
        this._CSS = {
            baseClass: "cdx-ai-text",
            wrapper: "cdx-ai-text-wrapper",
            input: "cdx-ai-text-input",
            output: "cdx-ai-text-output",
            button: "cdx-ai-text-button",
            buttonContent: "cdx-ai-text-button-content",
            loader: "cdx-ai-text-loader",
        };
        this.api = api;
        this.readOnly = readOnly;
        // Initialize configuration with environment variable fallback
        this._promptPlaceholder = (config === null || config === void 0 ? void 0 : config.promptPlaceholder) || "Type your prompt...";
        // Priority: config.apiKey > environment variables
        this._apiKey = (config === null || config === void 0 ? void 0 : config.apiKey) || getClientSideEnvVar('OPENAI_API_KEY') || "";
        this._maxTokens = (config === null || config === void 0 ? void 0 : config.maxTokens) || 8000;
        // Initialize data
        this._data = {
            prompt: data.prompt || "",
            generatedText: data.generatedText || "",
        };
        // Initialize OpenAI instance with the provided API key
        this._openai = new OpenAI({
            apiKey: this._apiKey,
            dangerouslyAllowBrowser: true
        });
        this._block = block;
    }
    Object.defineProperty(AITextTool, "toolbox", {
        // Define how the tool appears in the Editor.js toolbox
        get: function () {
            return {
                icon: 'Ai',
                title: "AI Text",
            };
        },
        enumerable: false,
        configurable: true
    });
    // Render the AI Text Tool block
    AITextTool.prototype.render = function () {
        var _this = this;
        // Create container div
        var container = document.createElement("div");
        container.classList.add(this._CSS.wrapper);
        // If we already have generated text, just show it as normal editable content
        if (this._data.generatedText) {
            var textDiv = document.createElement("div");
            textDiv.contentEditable = this.readOnly ? "false" : "true";
            textDiv.style.outline = "none";
            textDiv.style.minHeight = "40px";
            textDiv.textContent = this._data.generatedText;
            // Add class and attributes for EditorJS to recognize as editable content
            textDiv.classList.add("ce-paragraph");
            textDiv.setAttribute("data-placeholder", "");
            container.appendChild(textDiv);
            return container;
        }
        // Otherwise, show the prompt input with arrow button
        var inputWrapper = document.createElement("div");
        inputWrapper.classList.add(this._CSS.input);
        inputWrapper.style.display = "flex";
        inputWrapper.style.alignItems = "center";
        inputWrapper.style.gap = "8px";
        // Create the prompt input div
        var promptInput = document.createElement("div");
        promptInput.contentEditable = this.readOnly ? "false" : "true";
        promptInput.style.flex = "1";
        promptInput.style.outline = "none";
        promptInput.style.display = "inline";
        promptInput.textContent = this._data.prompt || "";
        promptInput.dataset.placeholder = this._promptPlaceholder;
        // Create inline loading spinner (hidden by default)
        var inlineLoader = document.createElement("span");
        inlineLoader.style.cssText = "\n      display: none;\n      margin-left: 4px;\n    ";
        inlineLoader.innerHTML = '<div class="' + this._CSS.loader + '"></div>';
        // Create the generate button (arrow)
        var generateButton = document.createElement("button");
        generateButton.classList.add(this._CSS.button);
        generateButton.innerHTML = "→";
        generateButton.title = "Generate AI text";
        // Function to handle generation
        var handleGenerate = function () { return __awaiter(_this, void 0, void 0, function () {
            var prompt, generatedText, currentBlockIndex_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        prompt = promptInput.innerText;
                        // Hide arrow button and show inline spinner next to text
                        generateButton.style.display = "none";
                        inlineLoader.style.display = "inline";
                        return [4 /*yield*/, this.generateText(prompt, promptInput)];
                    case 1:
                        generatedText = _a.sent();
                        // Hide inline spinner
                        inlineLoader.style.display = "none";
                        // Save the final generated text and prompt
                        if (generatedText) {
                            this._data.generatedText = generatedText;
                            this._data.prompt = prompt;
                            currentBlockIndex_1 = this.api.blocks.getCurrentBlockIndex();
                            // Clear the container to prevent EditorJS from seeing old content during deletion
                            container.innerHTML = "";
                            // Use setTimeout to ensure EditorJS processes the clear before we delete/insert
                            setTimeout(function () {
                                // Delete the current AI Text Tool block first
                                _this.api.blocks.delete(currentBlockIndex_1);
                                // Insert a new paragraph block with the generated text at the same position
                                _this.api.blocks.insert('paragraph', { text: generatedText }, {}, currentBlockIndex_1, true);
                            }, 10);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        // Event listener for clicking arrow button
        generateButton.addEventListener("click", handleGenerate);
        // Allow Enter key to trigger generation
        promptInput.addEventListener("keydown", function (e) {
            if (e.key === "Enter" && !e.shiftKey) {
                e.preventDefault();
                if (promptInput.innerText.trim() !== "") {
                    handleGenerate();
                }
            }
        });
        // Show button when user types
        promptInput.addEventListener("input", function () {
            if (promptInput.innerText.trim() !== "") {
                generateButton.style.display = "block";
            }
            else {
                generateButton.style.display = "none";
            }
        });
        // Initially hide button if no prompt
        if (!promptInput.textContent.trim()) {
            generateButton.style.display = "none";
        }
        // Assemble the container
        inputWrapper.appendChild(promptInput);
        inputWrapper.appendChild(inlineLoader);
        inputWrapper.appendChild(generateButton);
        container.appendChild(inputWrapper);
        return container;
    };
    // Save the block's data
    AITextTool.prototype.save = function (blockContent) {
        var _a, _b;
        // If we have generated text, get it from the simple text div
        if (this._data.generatedText) {
            var textDiv = blockContent.querySelector('div[contenteditable]');
            var currentText = textDiv ? ((_a = textDiv.textContent) === null || _a === void 0 ? void 0 : _a.trim()) || "" : "";
            return {
                prompt: this._data.prompt || "",
                generatedText: currentText,
            };
        }
        // Otherwise, save the prompt
        var inputWrapper = blockContent.querySelector(".".concat(this._CSS.input));
        var contentElement = inputWrapper === null || inputWrapper === void 0 ? void 0 : inputWrapper.querySelector('div[contenteditable]');
        var text = contentElement ? ((_b = contentElement.textContent) === null || _b === void 0 ? void 0 : _b.trim()) || "" : "";
        return {
            prompt: text,
            generatedText: "",
        };
    };
    // Async function to generate text using the OpenAI SDK with streaming
    AITextTool.prototype.generateText = function (prompt, outputElement) {
        var _a, e_1, _b, _c;
        var _d;
        return __awaiter(this, void 0, void 0, function () {
            var stream, fullText, chunkCount, _e, stream_1, stream_1_1, chunk, delta, content, e_1_1, error_1;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        _f.trys.push([0, 18, , 19]);
                        console.log("Generating text with prompt:", prompt);
                        console.log("API Key present:", !!this._apiKey);
                        if (!this._apiKey) {
                            console.error("No API key provided");
                            return [2 /*return*/, "Error: No API key configured. Please add your OpenAI API key."];
                        }
                        if (!prompt || prompt.trim() === "") {
                            console.warn("Empty prompt provided");
                            return [2 /*return*/, "Please enter a prompt first."];
                        }
                        return [4 /*yield*/, this._openai.chat.completions.create({
                                model: "gpt-4o-mini",
                                messages: [
                                    { role: "system", content: "You are a helpful assistant. Provide responses in plain text without any markdown formatting (no asterisks, underscores, backticks, etc.)." },
                                    { role: "user", content: prompt },
                                ],
                                max_tokens: this._maxTokens,
                                stream: true,
                            })];
                    case 1:
                        stream = _f.sent();
                        console.log("Streaming started...");
                        fullText = "";
                        chunkCount = 0;
                        _f.label = 2;
                    case 2:
                        _f.trys.push([2, 11, 12, 17]);
                        _e = true, stream_1 = __asyncValues(stream);
                        _f.label = 3;
                    case 3: return [4 /*yield*/, stream_1.next()];
                    case 4:
                        if (!(stream_1_1 = _f.sent(), _a = stream_1_1.done, !_a)) return [3 /*break*/, 10];
                        _c = stream_1_1.value;
                        _e = false;
                        _f.label = 5;
                    case 5:
                        _f.trys.push([5, , 8, 9]);
                        chunk = _c;
                        chunkCount++;
                        // Log first few chunks to debug
                        if (chunkCount <= 3) {
                            console.log("Chunk ".concat(chunkCount, ":"), JSON.stringify(chunk));
                        }
                        delta = (_d = chunk.choices[0]) === null || _d === void 0 ? void 0 : _d.delta;
                        content = (delta === null || delta === void 0 ? void 0 : delta.content) || "";
                        if (!content) return [3 /*break*/, 7];
                        fullText += content;
                        if (!outputElement) return [3 /*break*/, 7];
                        // Use textContent for better performance and preserve formatting
                        outputElement.textContent = fullText;
                        // Add a small delay to create a typing effect (20ms per chunk)
                        return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 20); })];
                    case 6:
                        // Add a small delay to create a typing effect (20ms per chunk)
                        _f.sent();
                        _f.label = 7;
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        _e = true;
                        return [7 /*endfinally*/];
                    case 9: return [3 /*break*/, 3];
                    case 10: return [3 /*break*/, 17];
                    case 11:
                        e_1_1 = _f.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 17];
                    case 12:
                        _f.trys.push([12, , 15, 16]);
                        if (!(!_e && !_a && (_b = stream_1.return))) return [3 /*break*/, 14];
                        return [4 /*yield*/, _b.call(stream_1)];
                    case 13:
                        _f.sent();
                        _f.label = 14;
                    case 14: return [3 /*break*/, 16];
                    case 15:
                        if (e_1) throw e_1.error;
                        return [7 /*endfinally*/];
                    case 16: return [7 /*endfinally*/];
                    case 17:
                        console.log("Total chunks received: ".concat(chunkCount));
                        console.log("Streaming complete. Full text:", fullText);
                        console.log("Full text length:", fullText.length);
                        if (fullText && fullText.trim().length > 0) {
                            return [2 /*return*/, fullText.trim()];
                        }
                        else {
                            console.warn("OpenAI response did not contain any content.");
                            return [2 /*return*/, "Error: No content received from AI."];
                        }
                        return [3 /*break*/, 19];
                    case 18:
                        error_1 = _f.sent();
                        console.error("Error generating text:", error_1);
                        return [2 /*return*/, "Error generating text: ".concat(error_1 instanceof Error ? error_1.message : 'Unknown error')];
                    case 19: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(AITextTool, "sanitize", {
        // Define what elements can be sanitized
        get: function () {
            return {
                prompt: {
                    br: true,
                },
                generatedText: {
                    br: true,
                },
            };
        },
        enumerable: false,
        configurable: true
    });
    return AITextTool;
}());
export default AITextTool;
